import { computed, defineComponent, onBeforeUnmount, onMounted, PropType, ref, watch, watchEffect } from "vue";
import AccordionArrowIcon from "../../assets/accordion-arrow-icon.vue";
import SearchIcon from "@/assets/search-icon.vue";
import store from "../../store";
import { FacetList, facetValue } from "../../interfaces/Filter";
import Bean from "../Bean/Bean.vue";
import { useStore } from 'vuex';
import { NButton, NIcon, NInput, NSlider, NSwitch } from "naive-ui";
import { InputProps, SwitchProps } from 'naive-ui'
import { createSimulatedFilter } from "@/utils-helpers";

type InputThemeOverrides = NonNullable<InputProps['themeOverrides']>
type SelectThemeOverrides = NonNullable<SwitchProps['themeOverrides']>

const inputThemeOverrides: InputThemeOverrides = {
  paddingMedium: 'none',
  lineHeight: '20px',
  borderFocus: 'none',
  caretColor: '#222222',
  borderHover: 'none',
  iconSize: '24px',
  borderRadius: '48px',
  border: 'none',
  boxShadowFocus: 'none',
  placeholderColor: '#222222'
}

const switchThemeOverrides: SelectThemeOverrides = {
  boxShadowFocus: 'none',
  railColorActive: '#575D9B',
  railHeightMedium: '24px',
  railWidthMedium: '44px',
  railColor: '#CEDBF4',
}

export default defineComponent({
  name: 'FilterOption',
  components: {
    AccordionArrowIcon,
    SearchIcon,
    Bean,
    NSwitch,
    NInput,
    NIcon,
    NButton,  // Aggiungi il componente NButton per i bottoni predefiniti
    NSlider,
  },
  props: {
    entries: {
      type: Array as PropType<FacetList[]>,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    filterLabel: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true,
    },
    openIndex: {
      type: Number,
      default: null,
    },
    value: {
      type: String,
      required: true
    }

  },
  emits: ['updateOpenIndex'],
  setup(props, { emit }) {
    // Definisci la proprietà isOpenAccordion come una variabile reattiva
    const localEntries = ref([...props.entries]);
    const store = useStore();
    // Calcola se l'accordion corrente è aperto
    const isOpen = computed(() => props.index === props.openIndex);

    const searchQuery = ref('');
    const brandLength = Object.keys(window.mostClickedBrands).length;
    const minPriceFilter = store.state.minPriceFilter;  // Recuperato dal Vuex store
    const maxPriceFilter = store.state.maxPriceFilter; 
    const priceRange = ref([minPriceFilter, maxPriceFilter]);
    const isSelectedPrice = (singleFilter: facetValue) => { // Funzione per verificare se un filtro prezzi è selezionato
      return store.state.selectedFilters.some(
        (selected: { value: string; }) => selected.value === singleFilter.value
      );
    };

    const toggleAccordion = () => {
      const stickyElement = document.querySelector(`.accordion-header-brand`);
      if (stickyElement) {
        stickyElement.classList.remove('sticky');
      }
      emit('updateOpenIndex', props.index);
    };




    const handleSwitchChange = (filter: facetValue) => {
      store.dispatch('toggleFilter', filter);
    };

    // Funzione per gestire il debounce
    const debounce = (func: (...args: any[]) => void, wait: number) => {
      let timeout: ReturnType<typeof setTimeout>;
      return (...args: any[]) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
      };
    };



    const updatePriceRange = (newRange: number[], filterValue: any) => {
      if (newRange[0] > newRange[1]) {
        newRange = [newRange[1], newRange[0]]; // Corregge inversione
      }
      updatePriceFilter(filterValue); // Passa filterType alla funzione di aggiornamento dei filtri
    };

    const debouncedUpdatePriceRange = debounce(updatePriceRange, 500);

    // Funzione chiamata dallo slider
    const onSliderChange = (newRange: number[]) => {
      debouncedUpdatePriceRange(newRange, props.value);
    };

    const updatePriceFilter = (filterValue: string) => {

      const simulatedFilter = createSimulatedFilter(filterValue, [priceRange.value[0], priceRange.value[1]], false)


      // Your logic to update or use the simulated filter goes here
      store.dispatch('toggleFilter', simulatedFilter);
    };


    const setPresetPrice = (preset: facetValue) => {
      // Decodifica la stringa URL-encoded
      const decodedPreset = decodeURIComponent(preset.value);

      // Usa una regex per estrarre i valori min e max
      const match = decodedPreset.match(/(?:\{(\*|\d+\.?\d*)\s*\+?(\*|\d+\.?\d*)\})/);

      if (match) {
        // Estrai min e max dalla regex
        const min = match[1] === '*' ? null : parseFloat(match[1]);  // Se * è presente, min è null
        const max = match[2] === '*' ? null : parseFloat(match[2]);  // Se * è presente, max è null

        // Gestisci i casi con min e max
        if (min === null && max !== null) {
          priceRange.value = [0, max];  // Imposta solo max, min è 0
        } else if (min !== null && max !== null) {
          priceRange.value = [min, max];  // Imposta entrambi min e max
        } else if (min !== null && max === null) {
          priceRange.value = [min, maxPriceFilter];  // Imposta min e usa maxPriceFilter per max
        } else if (min === null && max === null) {
          // Gestisci il caso in cui entrambi sono null (per esempio "*+*")
          priceRange.value = [minPriceFilter, maxPriceFilter];  // Imposta 0 per min e maxPriceFilter per max
        }

        store.dispatch('toggleFilter', preset);
      }
    };

    watch(priceRange, ([min, max]) => {
      if (min > max) {
        priceRange.value = [max, min]; // Corregge se i valori sono invertiti
      }
    });





    watch(() => props.entries, (newEntries, oldEntries) => {
      console.log('entries new:', newEntries);
      console.log('entries old:', oldEntries);
    });

    watch(() => props.entries, (newEntries) => {
      localEntries.value = [...newEntries];
    });



    const isActive = computed(() => {
      return store.state.selectedFilters.some(
        (selected: facetValue) => selected.value === props.entries[0].value
      );
    });

    const filteredEntries = computed(() => {
      // Numero configurabile di brand "più cliccati"
      const topBrandCount = 3;

      // Separa i brand più cliccati dai non più cliccati
      const mostClickedBrands = localEntries.value.slice(0, topBrandCount);
      const otherBrands = localEntries.value.slice(topBrandCount);

      // Filtra separatamente le due sezioni
      const filteredMostClicked = searchQuery.value
        ? mostClickedBrands.filter(entry =>
          entry.label.toLowerCase().includes(searchQuery.value.toLowerCase())
        )
        : mostClickedBrands;

      const filteredOtherBrands = searchQuery.value
        ? otherBrands.filter(entry =>
          entry.label.toLowerCase().includes(searchQuery.value.toLowerCase())
        )
        : otherBrands;

      // Mantieni le due sezioni separate
      return {
        filteredMostClicked,
        filteredOtherBrands,
      };
    });



    const onSearch = () => {
      console.log('Query di ricerca aggiornata:', searchQuery.value);
    };

    watch(searchQuery, (newQuery) => {
      console.log('Valore di searchQuery:', newQuery); // Questo dovrebbe mostrare il valore aggiornato

    });

    watch(
      () => store.state.selectedPriceRange,
      (newRange) => {
        if (props.filterLabel === 'Price') {
          priceRange.value = [newRange[0], newRange[1]];
        }
      }
    );

    onMounted(() => {
      if (props.filterLabel == 'Price') {
        const selectedRange = store.state.selectedPriceRange;
        priceRange.value = [selectedRange[0], selectedRange[1]];
      }

    });




    return {
      isOpen,
      toggleAccordion,
      entries: localEntries, // Rendi le props disponibili nel template
      name: props.name,// Rendi le props disponibili nel template
      filterType: props.type,
      filterValueWithoutEntry: props.value,
      handleSwitchChange,
      isActive,
      brandLength,
      filteredEntries,
      searchQuery,
      onSearch,
      inputThemeOverrides,
      switchThemeOverrides,
      priceRange,
      setPresetPrice, // Rendi disponibile setPresetPrice per il template
      updatePriceRange,
      onSliderChange,
      minPriceFilter,
      maxPriceFilter,
      isSelectedPrice
    }
  },
});
